<template lang="pug">
    .accept-cookies-modal-backdrop
        manage-cookies-modal(v-if="manageCookies" @close="close" @save="acceptSettings($event)")
        .accept-cookies-modal(v-else)
            .accept-cookies-modal__close(@click="close")
                img(src="/images/client/got-me-hookd/re-modal-close-button.svg" alt="close")
            .accept-cookies-modal__title This website uses cookies
            .accept-cookies-modal__text {{ text }} 
                a(href="/cookie-policy" target="_blank") Learn more
            .accept-cookies-modal__buttons
                re-button.re-button--inline.re-button--sm.re-button--secondary(@click="manage") Manage cookies
                re-button.re-button--inline.re-button--sm.re-button--primary(@click="close") Decline
                re-button.re-button--inline.re-button--sm.re-button--primary(@click="acceptAll" :loading="accepting") Accept

</template>

<script>
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'

export default {
    name: 'accept-cookies-modal',

    props: {
        level: {
            type: Number,
            required: true,
        },
    },

    data() { return {
        text: 'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.',
        accepting: false,
        manageCookies: false,
        targetingCookies: false,
    }},

    methods: {
        async accept() {
            const { data: { cookie } } = await axios.post('/api/customer/gdpr/accept-cookies', {
                url: window.location.href,
                text: this.text,
                targeting: this.targetingCookies,
            })

            EventBus.$emit('cookies-accepted', cookie)

            this.close()
        },

        acceptAll() {
            this.targetingCookies = true
            this.accept()
        },

        acceptSettings(settings) {
            this.targetingCookies = settings.targetingCookies
            this.accept()
        },

        close() {
            EventBus.$emit(Events.CLOSE_MODAL, this.level)
        },

        manage() {
            this.manageCookies = true
        },
    },
}
</script>
